import { Dispatcher } from "../../../../react-core/Flux/Dispatcher";

import { IExtendSessionActions } from "./ExtendSessionActions";

import { PayloadStore } from "../../../../react-core/Flux/PayloadStore";
import { ISessionInfoActions } from "./SessionInfoActions";
import { ISessionSettingActions } from "./SessionSettingActions";

export const ExtendSessionDispatcher = new Dispatcher<IExtendSessionActions>();

export const ExtendSessionStore = new PayloadStore(ExtendSessionDispatcher);

export const SessionInfoDispatcher = new Dispatcher<ISessionInfoActions>();

export const SessionInfoStore = new PayloadStore(SessionInfoDispatcher);

export const SessionSettingDispatcher = new Dispatcher<ISessionSettingActions>();

export const SessionSettingStore = new PayloadStore(SessionSettingDispatcher);
